import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import path from '../helpers/path';
import APIcon from '@alphapoint/apex-web/lib/components/common/APIcon';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import StandAloneLayout from '../layouts/StandAloneLayout/StandAloneLayout';
import redirectIfAuthorized from '@alphapoint/apex-web/lib/hocs/redirectIfAuthorized';

import SimpleProblemLoggingInFormContainer from '@alphapoint/apex-web/lib/components/SimpleProblemLoggingIn/SimpleProblemLoggingInFormContainer';

import '../styles/components/common/StandaloneForm.css';
import './ProblemLoggingInPage.css';
import config from '../config';

const { useEmailAsUsername } = config.SignupForm;
const baseClasses = getBEMClasses('standalone-form');
const problemLoggingInPageClasses = getBEMClasses('problem-logging-in-page');

const ProblemLoggingInPage = () => {
  const { t } = useTranslation();

  return (
    <StandAloneLayout>
      <div className={`${baseClasses('container')} ${problemLoggingInPageClasses('container')}`}>
        <div className={`${baseClasses('header')} ${problemLoggingInPageClasses('header')}`}>
          <div className={`${baseClasses('header-text')} ${problemLoggingInPageClasses('header-text')}`}>
            {t('Problems Logging In?')}
          </div>
          <Link to={path('/')} className={baseClasses('close-icon')}>
            <APIcon name="close" classModifiers="big" />
          </Link>
        </div>

        <SimpleProblemLoggingInFormContainer showOptions useEmailAsUsername={useEmailAsUsername} />

        <div className={`${baseClasses('footer')} ${problemLoggingInPageClasses('footer')}`}>
          <Link to={path('/login')} className={problemLoggingInPageClasses('link')}>
            {t('Log In')}
          </Link>
        </div>
      </div>
    </StandAloneLayout>
  );
};

export default redirectIfAuthorized(ProblemLoggingInPage);
